module.exports = __webpack_public_path__ + "static/media/camera_icon_white.1612b46a.svg";